import { debounce } from 'debounce';
import { CustomElement } from './custom-element';
import { MESSAGES } from 'constants/communication';
import { FREQUENT_EVENT_THROTTLE_MS } from 'configuration/defaults';

const ESCAPE_KEY = 27;

export class LightboxCustomElement extends CustomElement {
    constructor(...args) {
        super(...args);

        this.dispatcher.addEventListener('play', event => this.showPlayer(event));
        this.dispatcher.addEventListener('previewhidden', event => this.showPlayer(event));
        this.dispatcher.addEventListener('outsideclick', () => this.hidePlayer());
        this.dispatcher.addEventListener('escapekey', () => this.hidePlayer());
    }

    showPlayer(event) {
        if (this.displayed) {
            return;
        }

        this.displayed = true;
        this.playerContainer.style.margin = 'auto';
        this.embed.setAttribute('data-presentation', this.presentation);
        document.body.addEventListener('keyup', this.onKeyUp);
    }

    hidePlayer() {
        const { fixedWidth } = this.fixedDimensions;

        this.displayed = false;
        this.embed.setAttribute('data-presentation', this.presentation);
        this.playerContainer.style.margin = '';
        this.player && this.player.pause();
        this.player.showPreview();
        document.body.removeEventListener('keyup', this.onKeyUp);
    }

    onKeyUp = event => {
        if (event.keyCode === ESCAPE_KEY) {
            this.hidePlayer();
        }
    }

    get playerArgs() {
        return {
            ...super.playerArgs,
            scaleToContainer: !this.hasFixedDimensions
        }
    }

    get presentation() {
        return this.displayed ? 'lightbox' : 'inline';
    }
}